import { useTranslation } from "react-i18next"

import { ALL_ALERTS_SEARCH_PARAMS } from "helpers/config/tabs/constants"
import NoticePanel from "widgets/common/NoticePanel"

// Temporary: drop it once users stop looking for alert settings here.
const AlertSettingsMovedNotice = () => {
  const { t } = useTranslation()

  return (
    <NoticePanel
      body={t("alerts.ALERT_SETTINGS_MOVED")}
      action={{
        label: t("alerts.GO_TO_ALERTS"),
        href: `../alerts?${ALL_ALERTS_SEARCH_PARAMS}`,
      }}
    />
  )
}

export default AlertSettingsMovedNotice
